export default theme => ({
  footerLink: {
    color: theme.palette.white.main,
    marginRight: 10,
    textDecoration: "none",
    cursor: "pointer",
  },
});
